import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { ShareDataService } from '@services/share-data.service';
import { UsersService } from '@services/users.service';
import { Subject, Subscription } from 'rxjs';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'add-user-dialog',
  templateUrl: 'add-user-dialog.html',
  styleUrls: ['./add-user-dialog.scss'],
})
export class AddUSerDialog implements OnInit {
  [x: string]: any;
  usersData: any;
  noDataFound = true;
  sort: any;
  // paginator: any;
  displayedColumns: string[] = ['checkbox', 'firstName', 'emailId', 'role'];
  userStatus: any;
  totalRecords: any;
  searchText: any;
  page: number = 1;
  itemName = "";
  searchValue = "";
  firstName = "";
  lastName = "";
  emailId = "";
  userslist: any;

  testName = "";
  itemDescription = "";
  testDescription = "";
  tagdescription = "";
  itemStatus = "";
  testStatus = "";
  isItemDescended = true;
  itemId = 10;
  userRoles: any;
  updateroleValue: any;
  userServiceSubscription$: Subscription | undefined;
  userFilterServiceSubscription$: Subscription | undefined;

  itemIds: any = [];
  itemJsonData: any = [];
  globalcollectionuuid: any;
  source: any;
  uselevelId: any;
  selectUserArr = [];
  selectedUserRoleArr = [];
  selectedUserRoleArrs = [];
  finalUserArr = [];
  dropdownSettings = {};
  selectedItems = [];
  errorFlag: boolean = false;
  usererrorflag: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  validateData = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  //   @ViewChild(MatSort) sort: MatSort;
  constructor(private collectionService: CollectionService,
    private shareDataService: ShareDataService,
    private router: Router,
    private routerState: ActivatedRoute,
    private appService: AppService,
    private usersService: UsersService,
    public dialogRef: MatDialogRef<AddUSerDialog>,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public translate: TranslateService,) { }

  ngOnInit(): void {
    this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    this.userServiceSubscription$ = this.usersService.getusers()?.subscribe(resData => {
      this.userslist = resData?.data;
      if (this.userslist.length > 0) {

        this.userslist.filter((x: any) => x.checked = false);
        this.usersData = new MatTableDataSource(this.userslist);

        this.noDataFound = false;
        this.setPaginator();
        this.usersData.filteredData.filter((x: any) => {    // set bydefault use levelid for Test Maneger
          x['userAccessLevelId']
          // x.userAccessLevelId = 3
          x.userAccessLevelId = 0   // default value is 0
        });
      } else {
        this.noDataFound = true;
      }

    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    this.collectionService.getRoleList().subscribe(role => {
      this.userRoles = role?.data;
      // this.userRoles.forEach((element,index) => {
      //   if(element.roleName == AccountAdminRole.accountAdmin) delete this.userRoles[index];
      // });
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
    // this.userslist.filter((x: any) => {
    // });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'roleId',
      textField: 'roleName',
      selectAllText: this.translate.instant('collectionById.assignUsers.dropdownSettings.selectAllText'),
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3
    };

  }

  setPaginator(): void {
    setTimeout(() => {
      this.usersData.paginator = this.paginator;
      this.usersData.sort = this.sort;

      // ------Set translation for pagination------
      if(this.usersData.paginator) {
        console.log(this.usersData.paginator)
        this.translate.stream([
          'collectionById.assignUsers.pagination.pageLabel',
          'collectionById.assignUsers.pagination.firstPage',
          'collectionById.assignUsers.pagination.lastPage',
          'collectionById.assignUsers.pagination.nextPage',
          'collectionById.assignUsers.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            this.usersData.paginator._intl.itemsPerPageLabel = translation['collectionById.assignUsers.pagination.pageLabel'];
            this.usersData.paginator._intl.firstPageLabel = translation['collectionById.assignUsers.pagination.firstPage'];
            this.usersData.paginator._intl.lastPageLabel = translation['collectionById.assignUsers.pagination.lastPage'];
            this.usersData.paginator._intl.nextPageLabel = translation['collectionById.assignUsers.pagination.nextPage'];
            this.usersData.paginator._intl.previousPageLabel = translation['collectionById.assignUsers.pagination.prevPage'];

            this.usersData.paginator._intl.changes.next();
        });
      }
    });
  }

  userFilter(): void {
    const options = '&keyword=' + this.searchValue;
    this.userFilterServiceSubscription$ = this.usersService.getUsersFilter(options)?.subscribe(
      (resData) => {
        this.usersData = resData?.data;
        if (this.usersData.length === 0) {
          this.noDataFound = true;
        }
        this.usersData = new MatTableDataSource(this.usersData);
        this.usersData.filteredData.filter((x: any) => {    // set bydefolt use levelid for Test Maneger
          x['userAccessLevelId']
          x.userAccessLevelId = 0
        });
        this.setPaginator();
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    this.noDataFound = false;

  }

  resetUserFilter(): void {
    this.searchValue = "";
    this.noDataFound = false;

    this.userServiceSubscription$ = this.usersService.getusers()?.subscribe(resData => {
      this.userslist = resData?.data;
      this.userslist.filter((x: any) => x.checked = false);
      this.selectedUserRoleArr = []
      this.selectUserArr = [];
      this.usersData = new MatTableDataSource(this.userslist);
      this.usersData.filteredData.filter((x: any) => {    // set bydefolt use levelid for Test Maneger
        x['userAccessLevelId']
        x.userAccessLevelId = 0 // by default use levelid is 0
      });
      this.setPaginator();
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  toggleCheckbox(event, selectedUser: any) {
    selectedUser.checked = event?.checked;
    this.selectUserArr.push(selectedUser);
    this.validateData.push(selectedUser);
    this.selectUserArr = this.selectUserArr.filter(x => x.checked === true);
    // this.validateData = this.validateData.filter(x => x.checked === true);
  }

  changeRole(selectedRole: any): void {
    this.selectedUserRoleArr.push(selectedRole);
    this.validateData.push(selectedRole);
    this.selectedUserRoleArr = this.selectedUserRoleArr.filter((c, index) => {
      return this.selectedUserRoleArr.indexOf(c) === index;
    });

    this.validateData = this.validateData.filter((c, index) => {
      return this.validateData.indexOf(c) === index;
    });
  }

  onSelectAll(rows, selectedRoles: any): void {
    rows.userAccessLevelId = selectedRoles;
    this.selectedUserRoleArr.push(rows);
    this.selectedUserRoleArr = this.selectedUserRoleArr.filter((c, index) => {
      return this.selectedUserRoleArr.indexOf(c) === index;
    });
  }

  saveUsers(): void {
    this.errorFlag = false;
    this.usererrorflag  = false;
    if (this.selectUserArr.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('collectionById.assignUsers.errMsg1'), true, 'warn')
      return;
    }

    if (this.selectedUserRoleArr.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('collectionById.assignUsers.errMsg2'), true, 'warn');
      return;
    }

    for (var data of this.validateData) {
      if (data.checked && (data.userAccessLevelId == undefined || data.userAccessLevelId == 0 || data.userAccessLevelId.length == 0)) {
        this.webErrorService.customErrors(this.translate.instant('collectionById.assignUsers.errMsg2'), true, 'warn')
        // this.notificationService.warn('Select the Role(s) to be assigned');
        this.errorFlag  = true;
        return;
      }

      if ((!data.checked) && (data.userAccessLevelId != undefined && data.userAccessLevelId.length != 0)) {
        this.usererrorflag  = true;
        this.webErrorService.customErrors(this.translate.instant('collectionById.assignUsers.errMsg1'), true, 'warn')
        // this.notificationService.warn('Select the Role(s) to be assigned');
        return;
      }
    }

    this.selectUserArr.filter(x => {
      if (x.checked) {
        if (this.selectedUserRoleArr.length > 0) {
          if(x.userAccessLevelId != undefined && x.userAccessLevelId != 0) {
            x.userAccessLevelId.forEach(e => {
              e.userAccessLevelId =  e.roleId,
              e.userAccessLevel = e.roleName
              delete e.roleId
              delete e.roleName
            });
          }


          this.finalUserArr.push({
            active: x?.active,
            collectionuuId: this.globalcollectionuuid,
            userAccessLevel: x?.userAccessLevelId,
            useruuid: x?.useruuid
          });
        }
        // else {
        //   this.finalUserArr = this.selectUserArr.map(x => ({
        //     active: x?.active,
        //     collectionuuId: this.globalcollectionuuid,
        //     userAccessLevel: x?.userAccessLevelId || 3,
        //     userId: x?.userid
        //   }));
        // }
      }
    });

    this.collectionService.addUsertoCollection(this.finalUserArr).subscribe(resData => {
      this.notificationService.success(resData?.message);  // This line used to display message
      this.collectionService.addCollectionuser(this.itemJsonData);
      this.dialogRef.close();
      this.itemIds = [];
    },
      error => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        // if (this.selectedUserRoleArr.length === 0) {
        //   this.notificationService.warn(error?.error?.message);  // This line used to display Select the User to be assigned error message
        // } else {
        //   this.notificationService.warn(error?.error?.message);  // This line used to display  error message
        // }
      });
  }
}
